import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';

import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../services/ss-api.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

export interface IStatsVendorEmailDialogModel {
    title: string;
    subTitle: string;
    message: string;
}

@Component({
    selector: 'stats-vendor-email-member-dialog',
    styleUrls: ['./stats.vendor.email.dialog.css'],
    templateUrl: './stats.vendor.email.dialog.html'
})
export class StatsVendorEmailDialog extends DialogComponent<IStatsVendorEmailDialogModel, string> implements IStatsVendorEmailDialogModel, OnInit {
    IsBusy: boolean = false;

    title: string;
    subTitle: string;
    message: string;

    Form: FormGroup;

    Email: string;

    constructor(dialogService: DialogService,
        private sweetAlertService: SweetAlertService,
        private api: ssApiService,
        private gb: GlobalService,
        public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.Email = this.gb.Email;
        this.setUpForm();
    }

    setUpForm() {
        this.Form = new FormGroup({
            'Email': new FormControl('', [Validators.required, Validators.email]),
        });
    }

    confirm() {
        this.result = this.Email;
        this.close();
    }

    cancel() {
        this.result = 'cancelled';
        this.close();
    }


}
